import HttpClient from '../services/HttpClient'
import { ROLES_PATH, ACTIVE_ROLES, ALLOWED_ROLES } from '../constants'
import TRANSLATE from 'utils/constants'

export const saveRole = formData => {
   return new Promise((resolve, reject) => {
      HttpClient.post(
         `${process.env.REACT_APP_ROLES_API}${ROLES_PATH}`,
         formData
      )
         .then(response => {
            resolve(response)
         })
         .catch(error => {
            if (typeof error.response === 'undefined') {
               console.log('A network error occurred. ')
               reject({
                  error: 'technical_error',
                  error_description:
                     'Ocurrió un problema comuniquese con el administrador.'
               })
            }
            resolve(error.response)
         })
   })
}

export const editRole = (id, payload) => {
   return new Promise((resolve, reject) => {
      HttpClient.put(
         `${process.env.REACT_APP_ROLES_API}${ROLES_PATH}/${id}`,
         payload
      )
         .then(response => {
            resolve(response)
         })
         .catch(error => {
            if (typeof error.response === 'undefined') {
               console.log('A network error occurred. ')
               reject({
                  error: 'technical_error',
                  error_description:
                     'Ocurrió un problema comuniquese con el administrador.'
               })
            }
            resolve(error.response)
         })
   })
}

export const filterRoles = urlParams => {
   return new Promise((resolve, reject) => {
      const headers = {
         'Content-Type': 'application/json'
      }
      HttpClient.get(
         `${process.env.REACT_APP_ROLES_API}${ROLES_PATH}/search/?${urlParams}`,
         headers
      )
         .then(response => {
            if (response.data.result) {
               resolve(response)
            }
            resolve(response)
         })
         .catch(error => {
            if (typeof error.response === 'undefined') {
               console.log('A network error occurred. ')
               reject({
                  error: 'technical_error',
                  error_description:
                     'Occurió un problema comuniquese con el administrador.'
               })
            }
            reject(error.response)
            resolve(error.response)
         })
   })
}

export const getAllRoles = () => {
   return new Promise((resolve, reject) => {
      const headers = {
         'Content-Type': 'application/json'
      }
      HttpClient.get(`${process.env.REACT_APP_ROLES_API}${ROLES_PATH}`, headers)
         .then(response => {
            if (response.data.result) {
               resolve(response)
            }
            resolve(response)
         })
         .catch(error => {
            if (typeof error.response === 'undefined') {
               console.log('A network error occurred. ')
               reject({
                  error: 'technical_error',
                  error_description:
                     'Occurió un problema comuniquese con el administrador.'
               })
            }
            reject(error.response)
            resolve(error.response)
         })
   })
}

export const setRoleToOperations = (rol, operations) => {
   return new Promise((resolve, reject) => {
      const body = { operationsId: operations }
      HttpClient.post(
         `${process.env.REACT_APP_ROLES_API}${ROLES_PATH}/${rol}/operations`,
         body
      )
         .then(response => {
            resolve(response)
         })
         .catch(error => {
            if (typeof error.response === 'undefined') {
               reject({
                  error: TRANSLATE.POST_ERROR,
                  error_description: TRANSLATE.POST_ERROR_ROL_OPERATION
               })
            }
            reject(error.response)
            resolve(error.response)
         })
   })
}

export const getAllActiveRolesApi = () => {
   return HttpClient.get(`${process.env.REACT_APP_ROLES_API}${ACTIVE_ROLES}`)
      .then(response => response.data)
      .catch(err => Promise.reject(err))
}

export const getAllAllowedRolesApi = () => {
   return HttpClient.get(
      `${process.env.REACT_APP_USERS_API}/users${ALLOWED_ROLES}`
   )
      .then(response => response.data)
      .catch(err => Promise.reject(err))
}
